import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Shield } from 'lucide-react';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    const grantConsent = () => {
        if (window.gtag) {
            window.gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
        }
    };

    const denyConsent = () => {
        if (window.gtag) {
            window.gtag('consent', 'update', {
                'ad_storage': 'denied',
                'analytics_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            });
        }
    };

    useEffect(() => {
        let shouldShow = true;
        try {
            const consent = localStorage.getItem('cookieConsent');
            if (consent === 'true') {
                grantConsent();
                shouldShow = false;
            } else if (consent === 'false') {
                denyConsent();
                shouldShow = false;
            } else {
                shouldShow = true;
            }
        } catch (e) {
            // iOS Safari in modalità privata blocca localStorage
            console.warn('LocalStorage access denied:', e);
            shouldShow = true;
        }
        // Piccolo delay per evitare race condition con il rendering React
        const timer = setTimeout(() => setIsVisible(shouldShow), 150);
        return () => clearTimeout(timer);
    }, []);

    const handleAccept = () => {
        try {
            localStorage.setItem('cookieConsent', 'true');
            grantConsent();
            // Invia subito la visualizzazione della pagina, che era bloccata dal consenso
            if (window.gtag) {
                window.gtag('event', 'page_view', {
                    page_location: window.location.href,
                    page_path: window.location.pathname + window.location.search,
                    page_title: document.title
                });
            }
        } catch (e) {
            console.error('Could not save cookie consent:', e);
        }
        setIsVisible(false);
    };

    const handleReject = () => {
        try {
            localStorage.setItem('cookieConsent', 'false');
            denyConsent();
        } catch (e) {
            console.error('Could not save cookie rejection:', e);
        }
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-industrial-900/95 backdrop-blur-md border-t border-white/10 p-4 md:p-6 z-[100] shadow-2xl animate-fade-in-up w-full overflow-hidden pb-[calc(1rem+env(safe-area-inset-bottom))]">
            <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-6 max-w-6xl">
                <div className="flex items-start gap-4">
                    <div className="p-3 bg-neon-amber/10 rounded-full hidden md:block">
                        <Shield className="w-6 h-6 text-neon-amber" />
                    </div>
                    <div className="space-y-2">
                        <h3 className="text-white font-bold text-lg">Informativa sulla Privacy & GDPR</h3>
                        <p className="text-slate-400 text-sm leading-relaxed max-w-2xl">
                            Utilizziamo cookie tecnici per garantire il corretto funzionamento del sito.
                            Compilando il modulo di contatto, accetti che i tuoi dati (nome, email, telefono) vengano
                            memorizzati esclusivamente per permetterci di ricontattarti in merito alla tua richiesta.
                            I tuoi dati non saranno ceduti a terzi.
                        </p>
                    </div>
                </div>
                <div className="flex gap-4 w-full md:w-auto">
                    <Button
                        variant="outline"
                        onClick={handleReject}
                        className="flex-1 md:flex-none border-white/20 text-slate-300 hover:bg-white/10 hover:text-white"
                    >
                        Rifiuta
                    </Button>
                    <Button
                        onClick={handleAccept}
                        className="flex-1 md:flex-none bg-neon-amber text-industrial-900 font-bold hover:bg-amber-600 shadow-[0_0_15px_rgba(245,158,11,0.3)]"
                    >
                        Accetto e Continuo
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
